import { getGuideStatus, saveGuideStatus } from '@/services/common';
import lodash from 'lodash';
import { useCallback, useEffect, useState } from 'react';

export const useGuideStatus = (props: { sceneCode: string }) => {
  const [guideStatus, setGuideStatus] = useState(true);
  const [emptyFlag, setEmptyFlag] = useState(false);

  useEffect(() => {
    fetchGuideStatus();
  }, []);

  const fetchGuideStatus = async () => {
    const res = await getGuideStatus({ sceneCode: props.sceneCode });
    setGuideStatus(res.completed);
    setEmptyFlag(res.completed);
  };
  const completed = useCallback(
    lodash.debounce(async () => {
      setGuideStatus(true);
      const res = await saveGuideStatus({ sceneCode: props.sceneCode });
      setEmptyFlag(true);
      window.localStorage.setItem(props.sceneCode, '1');
    }, 1000),
    [],
  );

  return { state: guideStatus, completed, emptyFlag, setEmptyFlag };
};

export default useGuideStatus;
